<div
  style="display: flex; justify-content: center; flex-direction: column"
  class="mx-6"
>
  <div class="my-8">
    <!--Top: carousel, name-->
    {{ regionName }} pics ... ... ...
  </div>
  <div style="display: flex; justify-content: space-between">
    <span>
      <i class="pi pi-map-marker"></i>
      {{ regionName }}
    </span>
    <span> {{ experienceNum }}+ esperienze </span>
  </div>

  <p-divider layout="horizontal" />
  <div>
    Scopri l'enoturismo in {{ regionName }}
    <p>Lorem {{regionName}} ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
  </div>

  <div style="display: flex; justify-content: center">
    <ng-template let-ter pTemplate="item">
        <div class="carouselExperiences">
            <p-carousel
              [value]="experiences"
              [numVisible]="4"
              [numScroll]="1"
              [responsiveOptions]="responsiveOptionsExperience"
            >
              <ng-template let-exp pTemplate="item">
                <app-experience-card
                  [experience]="exp"
                  (click)="linkToExperience(exp.id, exp.title)"
                ></app-experience-card>
              </ng-template>
            </p-carousel>
          </div>
    </ng-template>
    <button class="divineaButton" style="margin: 0.9rem">Scopri tutte</button>
  </div>

  <div style="display: flex; justify-content: space-between">
    <span> Esperienze in questa regione </span>
    <!--TODO-->
    <a href="">vedi tutte</a>
  </div>
  <div style="display: flex; justify-content: center">
    <button class="divineaButton" style="margin: 0.9rem">Scopri tutte</button>
  </div>

  <div style="display: flex; justify-content: space-between">
    <span> Scopri i principali territori vinicoli di questa regione e altre regioni nei d'intorni
    </span>
    <!--TODO-->
    <a href="">vedi tutte</a>
  </div>
  <div style="display: flex; justify-content: center">
    <button class="divineaButton" style="margin: 0.9rem">Scopri tutte</button>
  </div>

  <div style="display: flex; justify-content: space-between">
    <span> (Visita) Le cantine di questa regione </span>
    <!--TODO-->
    <a href="">vedi tutte</a>
  </div>
  <div style="display: flex; justify-content: center">
    <button class="divineaButton" style="margin: 0.9rem">Scopri tutte</button>
  </div>

  <div style="display: flex; justify-content: space-between">
    <span> Altre regioni nei d’intorni </span>
    <!--TODO-->
    <a href="">vedi tutte</a>
  </div>
  <div style="display: flex; justify-content: center">
    <button class="divineaButton" style="margin: 0.9rem">Scopri tutte</button>
  </div>
</div>
